import React from "react";

const IMAGES = [
  { src: "/images/hero.png", span: "md:col-span-6", h: "h-[60vh]" },
  { src: "/images/shirodhara.png", span: "md:col-span-6", h: "h-[60vh]" },
  { src: "/images/abhyanga.png", span: "md:col-span-4", h: "h-[40vh]" },
  { src: "https://images.pexels.com/photos/4113884/pexels-photo-4113884.jpeg?auto=compress&cs=tinysrgb&w=1000", span: "md:col-span-4", h: "h-[40vh]" },
  { src: "https://images.pexels.com/photos/4113927/pexels-photo-4113927.jpeg?auto=compress&cs=tinysrgb&w=1000", span: "md:col-span-4", h: "h-[40vh]" },
  { src: "/images/clinic_interior.png", span: "md:col-span-8", h: "h-[55vh]" },
  { src: "https://images.pexels.com/photos/8957037/pexels-photo-8957037.jpeg?auto=compress&cs=tinysrgb&w=1000", span: "md:col-span-4", h: "h-[55vh]" },
  { src: "https://images.pexels.com/photos/4505166/pexels-photo-4505166.jpeg?auto=compress&cs=tinysrgb&w=1000", span: "md:col-span-6", h: "h-[45vh]" },
  { src: "https://images.pexels.com/photos/4226805/pexels-photo-4226805.jpeg?auto=compress&cs=tinysrgb&w=1000", span: "md:col-span-6", h: "h-[45vh]" },
];

const Gallery = () => (
  <div data-testid="gallery-page">
    <section className="px-6 md:px-12 lg:px-20 pt-24 pb-16 md:pt-32">
      <p className="overline mb-6">Sanctuary</p>
      <h1 className="text-5xl sm:text-7xl tracking-tight font-light max-w-4xl leading-[1.05]">
        Where the work <em className="font-display italic" style={{ color: "var(--ayu-secondary)" }}>happens.</em>
      </h1>
    </section>

    <section className="px-6 md:px-12 lg:px-20 pb-24">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
        {IMAGES.map((img, i) => (
          <div key={i} data-testid={`gallery-img-${i}`} className={`${img.span} ${img.h} overflow-hidden`}>
            <img src={img.src} alt="" loading="lazy" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
          </div>
        ))}
      </div>
    </section>
  </div>
);

export default Gallery;
